import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// api
import { changePW, changePWWithOrigin, signinWithPW } from "../../services/apis/auth";
import { getUserInfoFromAlcohol } from "../../services/apis/alcohol/user";
import { getUserInfoFromHearro } from "../../services/apis/hearro/user";
import { getUserInfoFromMomthera } from "../../services/apis/momthera/user";

// utils
import { validateConfirmPW, validatePW } from "../../utils/validation";
import { hasForbiddenChars, FORBIDDEN_CHARS_MSG } from '../../utils/sanitize';

// component
import CommonModal from "../../components/modal/CommonModal";


function ChangePWPage({type}) {
    const [newPW, setNewPW] = useState("");
    const [confirmPW, setConfirmPW] = useState("");
    const [originalPW, setOriginalPW] = useState("");
    
    const [invalidOriginalPW, setInvalidOriginalPW] = useState(false);

    const navigate = useNavigate();

    // general: 비밀번호 찾기 페이지에서 넘어온 경우, initial: 초기(임시) 비밀번호로 로그인한 경우, month6: 비밀번호 변경 6개월 경과된 경우 
    const { state } = useParams();

    const [showChangePWPopup, setShowChangePWPopup] = useState(false);
    const [showChangePWPopupGeneral, setShowChangePWPopupGeneral] = useState(false);


    const closeChangePWPopup = () => {
        sessionStorage.removeItem('loginID');
        setShowChangePWPopup(false);
        navigate('/dtx006/dashboard');
    }

    const ChangePWModalBody = (
        <div className="mypage_modal_body">비밀번호가 변경되었습니다.</div>
    )

    const ChangePWModalFooter = (
        <div className="mypage_modal_footer">
            <button className="submit complete" type="button" onClick={closeChangePWPopup}>확인</button>
        </div>
    )

    const closeChangePWPopupGeneral = () => {
        sessionStorage.removeItem('userInfo');
        setShowChangePWPopupGeneral(false);
        navigate(`/sign-in/${type}`);
    }

    const ChangePWModalGeneralBody = (
        <div className="mypage_modal_body">비밀번호가 재설정되었습니다.</div>
    )

    const ChangePWModalGeneralFooter = (
        <div className="mypage_modal_footer">
            <button className="submit complete" type="button" onClick={closeChangePWPopupGeneral}>확인</button>
        </div>
    )

    // submit 버튼 비활성화
    const disabledHandleSubmitBtn = () => {
        // 값을 모두 입력하세요.
        if(!newPW || !confirmPW || (state!=="general" && !originalPW)) {
            return true;
        }
        // 사용할 수 없는 비밀번호입니다.
        if(validatePW(newPW)==="non-valid"){
            return true;
        }
        // 기존 비밀번호와 새 비밀번호가 동일합니다.
        if(originalPW.trim()===newPW.trim()) {
            return true;
        }
        // 비밀번호가 일치하지 않습니다."
        if(validateConfirmPW(newPW, confirmPW)==="non-valid"){
            return true;
        }

        return false;
    }


    const handleSubmit = async () => {
        if (hasForbiddenChars(originalPW) || hasForbiddenChars(newPW) || hasForbiddenChars(confirmPW)) return;

        if(state!=="general" && !sessionStorage.getItem('loginID')){
            alert('로그인이 필요한 기능입니다.');
            navigate(`/sign-in/${type}`);
            return;
        }

        if(!newPW || !confirmPW || (state!=="general" && !originalPW)) {
            alert("값을 모두 입력하세요.");
            return;
        }

        if(validatePW(newPW)==="non-valid"){
            alert("사용할 수 없는 비밀번호입니다.")
            return;
        }

        if(originalPW.trim()===newPW.trim()) {
            alert("기존 비밀번호와 새 비밀번호가 동일합니다.");
            return;
        }

        if(validateConfirmPW(newPW, confirmPW)==="non-valid"){
            alert("비밀번호가 일치하지 않습니다.");
            return;
        }

        if(state==="general"){
            try{
                const userInfo = sessionStorage.getItem('userInfo');
                if(!userInfo) {
                    alert("재인증이 필요합니다.");
                    navigate(`/sign-in/${type}`);
                    return;
                }
                const request = {
                    ...JSON.parse(userInfo),
                    newPassword: newPW.trim()
                }    
                const res = await changePW(request);
                if(parseInt(res.status/200, 10)===1 && res.data.message==="OK"){
                    if(type==='dtx006'){
                        setShowChangePWPopupGeneral(true);
                    }else{
                        alert("비밀번호가 성공적으로 변경되었습니다.");
                        navigate(`/sign-in/${type}`);
                    }                    
                }else if(res.response && res.response.status===401 && res.response.data.message){
                    alert(res.response.data.message);
                }else{
                    throw new Error();
                }
            }catch{
                alert("비밀번호 변경에 실패하였습니다.");
            }finally{                
                sessionStorage.removeItem('userInfo');
            }
        }else{
            try{
                const request = {
                    username: sessionStorage.getItem('loginID'),
                    originPassword: originalPW.trim(),
                    newPassword: newPW.trim()
                }
                const res = await changePWWithOrigin(request);
                if(parseInt(res.status/200, 10)===1){
                    if(type!=="dtx006"){
                        alert("비밀번호가 성공적으로 변경되었습니다.");
                    }
                    
                    // dtx001 임시 비밀번호의 경우 -> 대시보드 페이지로 이동
                    if(type==="dtx001" && state==="initial"){
                        sessionStorage.removeItem('loginID');
                        navigate('/dtx001/dashboard');
                    // dtx002 임시 비밀번호의 경우 -> 환자 관리 페이지로 이동
                    }else if(type==="dtx002" && state==="initial"){
                        sessionStorage.removeItem('loginID');
                        navigate('/dtx002/patient-manage/list');
                    // dtx006(맘테라) 임시 비밀번호의 경우 -> 변경 완료 팝업창 호출
                    }else if(type==="dtx006" && state==="initial"){
                        setShowChangePWPopup(true);
                    }
                    // 6개월 경과 비밀번호의 경우 -> 로그인 성공하면 서비스 접속, 실패하면 로그인 페이지로 이동
                    else{
                        try{
                            const requestSignin = {
                                username: sessionStorage.getItem('loginID'),
                                password: newPW.trim()
                            }
                            const resSignin = await signinWithPW(requestSignin);
                            if(parseInt(resSignin.status/200, 10)===1){
                                localStorage.setItem(`${type}token`, JSON.stringify(resSignin.data));
                                let resInfo;
                                if(type==="dtx001"){
                                    resInfo = await getUserInfoFromAlcohol();
                                }else if(type==="dtx002"){
                                    resInfo = await getUserInfoFromHearro();
                                }else if(type==="dtx006"){
                                    resInfo = await getUserInfoFromMomthera();
                                }
                                if (parseInt(resInfo.status/200, 10)===1) {
                                    if(type==='dtx001'){
                                        navigate("/dtx001/dashboard");
                                    }else if(type==='dtx002'){
                                        navigate("/dtx002/patient-manage/list");
                                    }else if(type==='dtx006'){
                                        setShowChangePWPopup(true);
                                    }
                                }else{
                                    localStorage.removeItem(`${type}token`);
                                    throw new Error();
                                }
                            }else{
                                throw new Error();
                            }
                        }catch{
                            if(type!=='dtx006') navigate(`/sign-in/${type}`);
                            else setShowChangePWPopup(true);
                        }finally{
                            sessionStorage.removeItem('loginID');
                        }
                    }
                }else if(res.response && res.response.status===401 && res.response.data.code==="authentication-failed"){
                    setInvalidOriginalPW(true);
                }else if(res.response && res.response.status===401 && res.response.data.message){
                    alert(res.response.data.message);
                }else{
                    alert("비밀번호 변경에 실패하였습니다.");
                }
            }catch(err){
                console.error(err);
                alert("비밀번호 변경에 실패하였습니다.");
            }
        }        
    }

    const handleCancel = () => {
        if(state==="general"){
            sessionStorage.removeItem('userInfo');
            navigate(`/sign-in/${type}`);
        }else if(state==="initial" && type==="dtx001"){
            sessionStorage.removeItem('loginID');
            navigate('/dtx001/dashboard');
        }else if(state==="initial" && type==="dtx002"){
            sessionStorage.removeItem('loginID');
            navigate('/dtx002/patient-manage/list');
        }else if(state==="initial" && type==="dtx006"){
            navigate('/dtx006/dashboard');
        }else{
            sessionStorage.removeItem('loginID');
            navigate(`/sign-in/${type}`);
        }
    }

    useEffect(()=>{
        if(state==="general" && !sessionStorage.getItem('userInfo')){
            navigate(`/search-account/${type}`);
        }else if(state!=="general" && !sessionStorage.getItem('loginID')){
            alert('로그인이 필요한 기능입니다.');
            navigate(`/sign-in/${type}`);
        }
    },[])

    return (
        <div className="signinLayout" style={{ width: '100vw', height: '100vh' }}>
			<div className="signinLayout__wrapper">
				<div className="signinLayout__wrapper__header">
                    <span className="signinLayout__wrapper__header__title">
                        {type!=="dtx006" && "비밀번호 변경"}
                        {type==="dtx006" && state==="general" && "비밀번호 재설정"}
                        {type==="dtx006" && state==="initial" && "초기 비밀번호 변경"}
                        {type==="dtx006" && state==="month6" && "비밀번호 변경"}
                    </span>
                </div>
                <hr className="signinLayout__wrapper__divider" style={{ marginBottom: '1.25rem' }} />
                <div className="signinLayout__wrapper__description" style={{ marginBottom: state==="initial" ? '1.25rem' : '2.8125rem' }}>
                    {state==="initial" && <p>초기 비밀번호를 변경합니다. 지금 변경하지 않으셔도 마이페이지에서 비밀번호를 변경하실 수 있습니다.</p>}
                    {state==="month6" && <p>
                        {type==="dtx001" && "알코지니"}
                        {type==="dtx002" && "히어로"}
                        {type==="dtx006" && "맘테라"}
                        {" "}의료진 페이지는 개인정보를 보호하기 위하여 6개월마다 비밀번호 변경을 진행하고 있습니다.
                    </p>}
                    <p>- 영문, 숫자, 특수기호 중 3개 이상 조합으로 8~20자 입력해 주세요.</p>
                    <p>- 아이디, 전화번호 등 개인정보와 관련된 숫자 등은 사용하지마세요.</p>
                    {type!=="dtx006" && state!=="month6" && <p>- 비밀번호는 마이페이지&gt;정보관리에서 변경할 수 있습니다.</p>}
                    {type==="dtx006" && state!=="month6" && <p>- 비밀번호는 &apos;마이페이지&apos; 에서 변경할 수 있습니다.</p>}
                </div>
                <div className="signinLayout__wrapper__body">
                    {state!=="general" && <div
						className="signinLayout__wrapper__body__option"
						style={{ marginBottom: '2rem' }}
					>
						<span className="optionItem__label">기존 비밀번호</span>
						<div className="optionItem__content">
							<div
                                className="optionItem__content__input"
                                style={{ width: '40rem' }}
                            >
								<input
									type="password"
									value={originalPW}
									onChange={e => {
                                        setInvalidOriginalPW(false);
										setOriginalPW(e.target.value);
									}}
									maxLength={20}
                                    placeholder={type==="dtx006" && "기존 비밀번호를 입력해주세요."}
								/>
                                {invalidOriginalPW && <p className="optionItem__content__input__validation non_valid">비밀번호가 일치하지 않습니다.</p>}
                                {hasForbiddenChars(originalPW) && <p className="optionItem__content__input__validation non_valid">{FORBIDDEN_CHARS_MSG}</p>}
							</div>
						</div>
                    </div>}
                    <div
						className="signinLayout__wrapper__body__option"
						style={{ marginBottom: '2rem' }}
					>
						<span className="optionItem__label">새로운 비밀번호</span>
						<div className="optionItem__content">
							<div
                                className={`optionItem__content__input ${validatePW(newPW, originalPW)==="valid" ? "valid_input" : ""}  ${validatePW(newPW, originalPW)==="non-valid" ? "non_valid_input" : ""}`}
                                style={{ width: '40rem' }}
                            >
								<input
									type="password"
									value={newPW}
									onChange={e => {
										setNewPW(e.target.value);
									}}
									maxLength={20}
                                    placeholder={type==='dtx006' && "변경하실 비밀번호를 입력해주세요."}
								/>
                                {validatePW(newPW, originalPW)==="valid" && <p className="optionItem__content__input__validation valid">
                                    {type==="dtx006" ? "올바른 비밀번호 형식입니다." : "사용가능한 비밀번호입니다."}
                                </p>}
                                {validatePW(newPW, originalPW)==="non-valid" && <p className="optionItem__content__input__validation non_valid">
                                    {type==="dtx006" ? "올바른 비밀번호 형식이 아닙니다." : "사용할 수 없는 비밀번호입니다."}                                    
                                </p>}
							</div>
						</div>
                    </div>
                    <div
						className="signinLayout__wrapper__body__option"
						style={{ marginBottom: '4.375rem' }}
					>
						<span className="optionItem__label">새로운 비밀번호 확인</span>
						<div className="optionItem__content">
							<div
                                 className={`optionItem__content__input ${validateConfirmPW(newPW, confirmPW)==="valid" ? "valid_input" : ""}  ${validateConfirmPW(newPW, confirmPW)==="non-valid" ? "non_valid_input" : ""}`}
                                style={{ width: '40rem' }}
                            >
								<input
									type="password"
									value={confirmPW}
									onChange={e => {
										setConfirmPW(e.target.value);
									}}
									maxLength={20}
                                    placeholder={type==="dtx006" && "변경하실 비밀번호를 재입력해주세요."}
								/>
                                {validateConfirmPW(newPW, confirmPW)==="valid" && <p className="optionItem__content__input__validation valid">비밀번호가 일치합니다.</p>}
                                {validateConfirmPW(newPW, confirmPW)==="non-valid" && <p className="optionItem__content__input__validation non_valid">비밀번호가 일치하지 않습니다.</p>}
                                {hasForbiddenChars(confirmPW) && <p className="optionItem__content__input__validation non_valid">{FORBIDDEN_CHARS_MSG}</p>}
							</div>
						</div>
                    </div>
                    <div className="signinLayout__wrapper__body__footer multiple">
						<button
							className="submitButton"
                            onClick={handleSubmit}
                            disabled={disabledHandleSubmitBtn()}
						>
							{(state==="general" && type!=='dtx006') ? '설정하기' : '변경하기'}
						</button>
                        <button
							className="cancelButton"
                            onClick={handleCancel}
						>
							{state!=="initial" ? '취소' : '다음에 변경하기'}
						</button>
					</div>
                </div>
            </div>
            <CommonModal
                header="비밀번호 변경"
                body={ChangePWModalBody}
                footer={ChangePWModalFooter}
                show={showChangePWPopup}
                setClose={closeChangePWPopup}
                size="sm"
            />
            <CommonModal
                header="비밀번호 재설정"
                body={ChangePWModalGeneralBody}
                footer={ChangePWModalGeneralFooter}
                show={showChangePWPopupGeneral}
                setClose={closeChangePWPopupGeneral}
                size="sm"
            />
        </div>
    )
}

export default ChangePWPage;